import { IconElementsProps } from "../icon-elements-props.type";
import { iconSizes } from "../icon-sizes";

export function SocialInstagram(props: IconElementsProps) {
  const {
    className,
    primaryColor = "#00083C",
    width,
    height,
    size = "S",
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || iconSizes[size]}
      height={height || iconSizes[size]}
      viewBox="0 0 21 21"
      fill={primaryColor}
      className={className}
    >
      <g clipPath="url(#clip0_3983_1463)">
        <path
          d="M10 1.8562C12.6719 1.8562 12.9883 1.86792 14.0391 1.91479C15.0156 1.95776 15.543 2.12183 15.8945 2.25855C16.3594 2.43823 16.6953 2.65698 17.043 3.00464C17.3945 3.3562 17.6094 3.68823 17.7891 4.15308C17.9258 4.50464 18.0898 5.03589 18.1328 6.00854C18.1797 7.06323 18.1914 7.37964 18.1914 10.0476C18.1914 12.7195 18.1797 13.0359 18.1328 14.0867C18.0898 15.0632 17.9258 15.5906 17.7891 15.9421C17.6094 16.407 17.3906 16.7429 17.043 17.0906C16.6914 17.4421 16.3594 17.657 15.8945 17.8367C15.543 17.9734 15.0117 18.1375 14.0391 18.1804C12.9844 18.2273 12.668 18.239 10 18.239C7.32813 18.239 7.01172 18.2273 5.96094 18.1804C4.98438 18.1375 4.45703 17.9734 4.10547 17.8367C3.64063 17.657 3.30469 17.4382 2.95703 17.0906C2.60547 16.739 2.39063 16.407 2.21094 15.9421C2.07422 15.5906 1.91016 15.0593 1.86719 14.0867C1.82031 13.032 1.80859 12.7156 1.80859 10.0476C1.80859 7.37573 1.82031 7.05933 1.86719 6.00854C1.91016 5.03198 2.07422 4.50464 2.21094 4.15308C2.39063 3.68823 2.60938 3.3523 2.95703 3.00464C3.30859 2.65308 3.64063 2.43823 4.10547 2.25855C4.45703 2.12183 4.98828 1.95776 5.96094 1.91479C7.01172 1.86792 7.32813 1.8562 10 1.8562ZM10 0.0554199C7.28516 0.0554199 6.94531 0.0671387 5.87891 0.114014C4.81641 0.160889 4.08594 0.332764 3.45313 0.578857C2.79297 0.83667 2.23438 1.17651 1.67969 1.73511C1.12109 2.28979 0.78125 2.84839 0.523438 3.50464C0.277344 4.14136 0.105469 4.86792 0.0585938 5.93042C0.0117188 7.00073 0 7.34058 0 10.0554C0 12.7703 0.0117188 13.1101 0.0585938 14.1765C0.105469 15.239 0.277344 15.9695 0.523438 16.6023C0.78125 17.2625 1.12109 17.821 1.67969 18.3757C2.23438 18.9304 2.79297 19.2742 3.44922 19.5281C4.08594 19.7742 4.8125 19.946 5.875 19.9929C6.94141 20.0398 7.28125 20.0515 9.99609 20.0515C12.7109 20.0515 13.0508 20.0398 14.1172 19.9929C15.1797 19.946 15.9102 19.7742 16.543 19.5281C17.1992 19.2742 17.7578 18.9304 18.3125 18.3757C18.8672 17.821 19.2109 17.2625 19.4648 16.6062C19.7109 15.9695 19.8828 15.2429 19.9297 14.1804C19.9766 13.114 19.9883 12.7742 19.9883 10.0593C19.9883 7.34448 19.9766 7.00464 19.9297 5.93823C19.8828 4.87573 19.7109 4.14526 19.4648 3.51245C19.2188 2.84839 18.8789 2.28979 18.3203 1.73511C17.7656 1.18042 17.207 0.83667 16.5508 0.582764C15.9141 0.33667 15.1875 0.164795 14.125 0.11792C13.0547 0.0671387 12.7148 0.0554199 10 0.0554199Z"
          fill={primaryColor}
        />
        <path
          d="M10 4.9187C7.16406 4.9187 4.86328 7.21948 4.86328 10.0554C4.86328 12.8914 7.16406 15.1921 10 15.1921C12.8359 15.1921 15.1367 12.8914 15.1367 10.0554C15.1367 7.21948 12.8359 4.9187 10 4.9187ZM10 13.3875C8.16016 13.3875 6.66797 11.8953 6.66797 10.0554C6.66797 8.21558 8.16016 6.72339 10 6.72339C11.8398 6.72339 13.332 8.21558 13.332 10.0554C13.332 11.8953 11.8398 13.3875 10 13.3875Z"
          fill={primaryColor}
        />
        <path
          d="M16.5391 4.71559C16.5391 5.37965 16 5.91481 15.3398 5.91481C14.6758 5.91481 14.1406 5.37575 14.1406 4.71559C14.1406 4.05153 14.6797 3.51637 15.3398 3.51637C16 3.51637 16.5391 4.05543 16.5391 4.71559Z"
          fill={primaryColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_3983_1463">
          <rect
            width={width || iconSizes[size]}
            height={height || iconSizes[size]}
            fill={primaryColor}
            transform="translate(0 0.0554199)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
